<template>
  <div style="width: 25%;">
    <div style="width:100%  display: flex;" class="eight">
      <span>付款渠道</span>
      <div id="eight" style="width:100%; height:400px
      ">
      </div>
    </div>
  </div>
</template>
<script>
import * as echarts from 'echarts';
export default {
  props: {
    list1: Array
  },
  name: "",
  data () {
    return {

    }
  },
  created () {
  },
  mounted () {
    this.initBie()
  },
  methods: {

    initBie () {
      var chartDom = document.getElementById('eight');
      var myChart = echarts.init(chartDom);
      var option;


      option = {
        color: ['#fac858',
          '#ee6666',
          '#73c0de',
          '#3ba272',
          '#fc8452',],
        title: {
          text: '',
          left: 'center'
        },
        tooltip: {
          trigger: 'item'
        },
        legend: {
          orient: 'vertical',
          left: 'left'
        },
        series: [
          {
            // name: this.list1.map(item=>{item.name}),
            type: 'pie',
            radius: '50%',
            data: this.list1,
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: 'rgba(0, 0, 0, 0.5)'
              }
            }
          }
        ]
      };
      window.onresize = function () {
        myChart.resize();
      }
      option && myChart.setOption(option);


    }
  },

  watch: {
    list1: {
      deep: true,
      handler (val) {
        this.initBie()
      },
    },
  },
  components: {

  },
}
</script>

<style scoped></style>




// WEBPACK FOOTER //
// src/statistics/components/income.vue